import { State } from "../types";

export default function maybeIsExcludedLocation({ isMeetupAllowed, isDeliveryAllowed, pickUpInfoToDisplay }: Partial<State>) {
    return Boolean(!isDeliveryAllowed && !isMeetupAllowed && !pickUpInfoToDisplay);
}